export const MOCK_PORTS_RESPONSE = {
  count: 4,
  total_pages: 1,
  current_page: 1,
  results: [
    { port: 443, protocol: 'tcp', state: 'open', host_domain: 'example.com', ip_address: '93.184.216.34' },
    { port: 80, protocol: 'tcp', state: 'open', host_domain: 'example.com', ip_address: '93.184.216.34' },
    { port: 22, protocol: 'tcp', state: 'filtered', host_domain: 'acme.io', ip_address: '104.21.15.80' },
    { port: 25, protocol: 'tcp', state: 'closed', host_domain: 'acme.io', ip_address: '104.21.15.80' },
  ],
}

export const MOCK_PORT_FILTER_OPTIONS = {
  protocol: ['tcp', 'udp'],
  state: ['open', 'filtered', 'closed'],
}
